// Pause app from moving forward if there is confirmation needed
export const pauseApp = () => {
  return {
    type: "PAUSE_APP",
  };
};

// Resume app from a paused state
export const resumeApp = () => {
  return {
    type: "RESUME_APP",
  };
};

export const showHeader = () => {
  return {
    type: "SHOW_HEADER",
  };
};

export const hideHeader = () => {
  return {
    type: "HIDE_HEADER",
  };
};

export const showLogoAndFooter = () => {
  return {
    type: "SHOW_LOGO_AND_FOOTER",
  };
};

export const hideLogoAndFooter = () => {
  return {
    type: "HIDE_LOGO_AND_FOOTER",
  };
};

export const modifyHeader = (headerTitle, headerContent) => {
  return {
    type: "MODIFY_HEADER",
    headerTitle,
    headerContent,
  };
};

export const changeBgColor = (color) => {
  return {
    type: "CHANGE_BG_COLOR",
    bgColor: color,
  };
};

export const processComplete = () => {
  return {
    type: "PROCESS_COMPLETE",
  };
};

// Change the payment type of the form to switch between debit and ach (for now)
export const changePaymentType = (paymentType) => {
  return {
    type: "CHANGE_PAYMENT_TYPE",
    paymentType,
  };
};

export const toggleEditMode = () => {
  return {
    type: "TOGGLE_EDIT_MODE",
  };
};



// WEBPACK FOOTER //
// ./src/actions/appStatus.actions.js